import Table from "components/commons/table";
import ViewList from "components/commons/view-list";
import { TABLE_HAPPINESS_INDEX_DETAIL } from "configs/hr-metrics/configTableHappinessIndexList";

export const HappinessIndexDetail = ({ 
    dataList,
    isLoading,
    query,
    modal,
    onChangeQuery,
    setShowModal
}) => {

    return (
        <>
            <div className={"flex items-center space-x-7 px-6 py-4"}>
                <ViewList
                    show={modal?.limit}
                    onShow={() => setShowModal({limit: true})}
                    onClose={() => setShowModal({limit: false})}
                    value={query?.limit}
                    onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                />
            </div>
            <Table
                className="my-3"
                name={TABLE_HAPPINESS_INDEX_DETAIL.name}
                columns={TABLE_HAPPINESS_INDEX_DETAIL.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({page: val})}
                onClickSort={(val) => onChangeQuery(val)}
                loading={isLoading}
            />
        </>
    )
}
